import "./sentry.ts";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import * as Sentry from "@sentry/react";

createRoot(document.getElementById("root")!, {
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
        console.error("Uncaught error", error, errorInfo.componentStack);
    }),
    onCaughtError: Sentry.reactErrorHandler(),
    onRecoverableError: Sentry.reactErrorHandler(),
}).render(<App />);
